import React, { lazy, Suspense, useEffect, Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';

import { ReactComponent as Calendar } from 'assets/icons/calendar.svg';
import { ReactComponent as Watch } from 'assets/icons/watch_later.svg';
import { ReactComponent as Location } from 'assets/icons/location_on.svg';
import { ReactComponent as CloseButton } from 'assets/icons/close.svg';
import MusicIcon from 'assets/icons/surround_sound.svg';

import DropdownMenu from 'components/dropdown';
import DropDownSelect from 'components/dropdownSelect';
import Button from 'components/button';
import Container from 'components/container';
import Loader from 'components/loader';
import { Row, Column } from 'components/grid';

import { SocialMedia, Share } from 'containers/MusicItemPage/elements';

import { useStateValue } from 'context/store';
import { setCurrency, setIsFree } from 'context/eventItem/actions';
import { openGallery } from 'context/gallery/actions';
import {
  addToCart,
  totalCost,
  openCart,
  closeCart,
  clearCart
} from 'context/cart/actions';

import {
  formatDate,
  formatTime,
  getMonth,
  getDate,
  getDay
} from 'utils/moment';
// import { scrollToTop } from 'utils/browserUtil';
import { useFetch } from 'utils/hooks';
import { numberFormat } from 'utils/stringUtil';
import { trackViewContent } from 'utils/analyticsUtil';

import { EVENTS_ENDPOINT } from 'constants.js';
import {
  Badge,
  Payment,
  TabsWrapper,
  Currency,
  Details,
  MoreEvents,
  Header,
  Title,
  MainImage,
  Tickets,
  MoreEventsDescription,
  EmbedText,
  TrailerWrapper,
  TrailerButtons
} from './elements';
import { currencies } from './constants';
import MetaHelmet from 'components/MetaHelmet';
import { extractContent2 } from 'utils';
import Dock from 'components/dock';
import Description from 'components/description';
import VideoPlayer from 'components/Player/VideoPlayer';
import {
  trackEventExit,
  trackEventView
} from 'containers/Cookies/EventTracker';

const BuyTicketCard = lazy(() =>
  import(
    /* webpackChunkName: "BuyTicketCard" */ 'components/card/BuyTicketCard'
  )
);

const EventsCard = lazy(() =>
  import(/* webpackChunkName: "EventsCard" */ 'components/card/EventsCard')
);

const NotFoundPage = lazy(() =>
  import(/* webpackChunkName: "NotFoundPage" */ 'containers/NotFoundPage')
);

function MobilePage(props) {
  const { res, loading, history, match, error } = props;
  const [toggleTrailer, setToggleTrailer] = useState(false);
  const { path } = match;

  const {
    state: { eventItem },
    dispatch
  } = useStateValue();

  const id = res.store.id || [];

  const { currency, tickets, filteredTickets, total } = eventItem;

  const newImg = new Image();
  newImg.src = res.thumbnail;

  useEffect(() => {
    // scrollToTop();
    trackViewContent(res);
    // eslint-disable-next-line
  }, [res.slug]);

  useEffect(() => {
    trackEventView(res.id, res.name);

    return () => {
      trackEventExit(res.id, res.name);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [stores, { loading: storeLoading }] = useFetch(
    [],
    `${EVENTS_ENDPOINT}?store_fk=${id}`,
    {
      method: 'GET'
    },
    'event_stores'
  );

  if (error) {
    return <NotFoundPage />;
  }

  if (loading) {
    return <Loader />;
  }

  const filteredStores = stores.filter(album => album.id !== res.id);
  const hasPrices = tickets.some(e => e.prices.length > 1);

  function sortBy(a, b) {
    return a.soldOut - b.soldOut;
  }

  function dataFields() {
    sessionStorage.setItem('dataFields', JSON.stringify(res.dataFields));
  }

  function handleAddToCart() {
    filteredTickets.map(ticket => dispatch(addToCart(ticket)));
    dispatch(openCart());
    setTimeout(() => dispatch(closeCart()), 3000);
    dispatch(totalCost());
    dataFields();
  }

  function handleBuyNow() {
    if (path && path.includes('embed')) {
      dispatch(clearCart());
    }
    if (filteredTickets.length) {
      filteredTickets.map(ticket => dispatch(addToCart(ticket)));
      dispatch(totalCost());
      dataFields();
      history.push(
        path && path.includes('embed') ? '/embed/checkout' : '/checkout'
      );
    } else {
      alert('Please select a ticket');
    }
  }

  function handleRSVPChekout() {
    if (path && path.includes('embed')) {
      dispatch(clearCart());
    }
    if (filteredTickets.length) {
      filteredTickets.map(ticket => dispatch(addToCart(ticket)));
      dispatch(totalCost());
      dataFields();
      res.isFree && dispatch(setIsFree(res.isFree));
      history.push(
        path && path.includes('embed') ? '/embed/checkout' : '/checkout'
      );
    } else {
      alert('Please select a ticket');
    }
  }

  function handleGallery() {
    const height = newImg.height;
    const width = newImg.width;

    const image = {
      thumbnail: res.thumbnail,
      name: res.name,
      width,
      height
    };
    dispatch(openGallery(image));
  }

  let countryCodes = [];

  if (hasPrices) {
    tickets.filter(ticket => {
      countryCodes = [
        ...countryCodes,
        ...ticket.prices.map(price => price.price_currency)
      ];
      return countryCodes;
    });
  }

  const availableCurrencies = [...new Set(countryCodes)].map(code => ({
    value: code,
    label: currencies.find(s => s.value === code).label
  }));

  const defaultCurrency = availableCurrencies.find(
    country => country.value === res.currency
  );

  const content = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        position: 'fixed',
        bottom: 0,
        marginLeft: -14,
        padding: '20px 14px 0',
        width: '100%',
        zIndex: 99,
        backgroundColor: '#fff'
      }}
    >
      {res.isFree ? (
        <Button onClick={handleRSVPChekout} width="100%" color="yellow">
          RSVP
        </Button>
      ) : (
        <>
          {path && !path.includes('embed') && (
            <Button
              onClick={handleAddToCart}
              style={{ marginRight: 14 }}
              width="100%"
            >
              Add to Cart
            </Button>
          )}
          <Button onClick={handleBuyNow} width="100%" color="yellow">
            Quick Buy
          </Button>
        </>
      )}
    </div>
  );

  return (
    <Suspense fallback={<div>{null}</div>}>
      <Header>
        <MetaHelmet
          title={res.name}
          description={extractContent2(`${res.description}`)}
          image={res.thumbnail}
          url={`/event/${res.slug}`}
        />
        <h3 style={{ textAlign: 'center', margin: 21 }}>{res.name}</h3>
        {path && !path.includes('no-poster') && (
          <MainImage
            style={{
              width: 330,
              height: 330,
              margin: 'auto',
              objectFit: 'contain',
              marginBottom: 21
            }}
            src={res.thumbnail}
            onClick={handleGallery}
          />
        )}
        <div style={{ marginBottom: 7 }}>
          <Title style={{ maxWidth: '100%' }}>
            {!res.isLive && (
              <Badge>
                {res.hasStreams ? (
                  <img src={MusicIcon} alt="Live Stream Icon" />
                ) : (
                  <h5 className="day">{getDay(res.startsAt)}</h5>
                )}

                <h5 className="date">{getDate(res.startsAt)}</h5>
                <h5 className="month">{getMonth(res.startsAt)}</h5>
              </Badge>
            )}
            <Details style={{ margin: 0 }}>
              {res.isLive ? (
                <span>
                  <img src={MusicIcon} alt="Live Stream Icon" />
                  <b>Live Now</b>
                </span>
              ) : (
                <>
                  <p>
                    <Location />
                    {res.hasStreams ? (
                      <b style={{ color: 'red' }}>Live Stream</b>
                    ) : (
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${res.venue}`}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {res.venue}
                      </a>
                    )}
                  </p>
                  <p>
                    <Calendar />
                    {formatDate(res.startsAt)} - {formatDate(res.endsAt)}
                  </p>
                  <p style={{ textTransform: 'lowercase' }}>
                    <Watch />
                    {formatTime(res.startsAt)} - {formatTime(res.endsAt)}
                  </p>
                </>
              )}
              <p style={{ marginBottom: 7 }}>by {res.store.name}</p>
            </Details>
          </Title>
          <Currency>
            {hasPrices ? (
              <DropDownSelect
                style={{ marginTop: 14 }}
                defaultValue={defaultCurrency}
                onChange={({ value }) => dispatch(setCurrency(value))}
                options={availableCurrencies}
              />
            ) : null}
          </Currency>
          <SocialMedia>
            <Share>
              <DropdownMenu
                mainTitle="Share"
                suffixIconDown={true}
                top={620}
                left="20px"
                width="200px"
                className="dropdown"
                menuItems={[
                  {
                    title: (
                      <FacebookShareButton
                        url={window.location.href}
                        quote={res.name}
                      >
                        Facebook
                      </FacebookShareButton>
                    ),
                    id: 'facebook'
                  },
                  {
                    title: (
                      <TwitterShareButton
                        url={window.location.href}
                        quote={res.name}
                      >
                        Twitter
                      </TwitterShareButton>
                    ),
                    id: 'twitter'
                  },
                  {
                    title: (
                      <WhatsappShareButton
                        url={window.location.href}
                        quote={res.name}
                      >
                        Whatsapp
                      </WhatsappShareButton>
                    ),
                    id: 'whatsapp'
                  }
                ]}
              />
            </Share>
          </SocialMedia>
        </div>
      </Header>
      {res.streams[0]?.trailer_url.length && (
        <>
          <TrailerButtons>
            {!toggleTrailer && (
              <button onClick={() => setToggleTrailer(true)}>
                Watch Trailer
              </button>
            )}
            {toggleTrailer && (
              <CloseButton onClick={() => setToggleTrailer(false)} />
            )}
          </TrailerButtons>
          {res.streams[0]?.trailer_url && toggleTrailer && (
            <TrailerWrapper>
              <VideoPlayer streams={res.streams} />
            </TrailerWrapper>
          )}
        </>
      )}
      <Tickets>
        <TabsWrapper>
          <Tabs>
            <TabList>
              <Tab>
                <h5>TICKETS</h5>
              </Tab>
              <Tab>
                <h5>ABOUT</h5>
              </Tab>
            </TabList>
            <TabPanel>
              <Row>
                {Array.isArray(tickets)
                  ? tickets.sort(sortBy).map(ticket => {
                      const price = ticket.prices.filter(
                        price => price.price_currency === currency
                      );
                      return price.length ? (
                        <Column key={ticket.id}>
                          <BuyTicketCard ticket={ticket} price={price} />
                        </Column>
                      ) : ticket.prices.length === 1 &&
                        ticket.prices[0].price_currency === 'RWF' ? (
                        <Fragment key={ticket.id}>
                          {dispatch(setCurrency('RWF'))}
                          <Column>
                            <BuyTicketCard
                              ticket={ticket}
                              price={ticket.prices}
                            />
                          </Column>
                        </Fragment>
                      ) : ticket.prices.length === 1 &&
                        ticket.prices[0].price_currency === 'USD' ? (
                        <Fragment key={ticket.id}>
                          {dispatch(setCurrency('USD'))}
                          <Column>
                            <BuyTicketCard
                              ticket={ticket}
                              price={ticket.prices}
                            />
                          </Column>
                        </Fragment>
                      ) : null;
                    })
                  : null}
              </Row>
              <Payment>
                <div className="subtotal">
                  <p>SUBTOTAL</p>
                  <p>
                    {currency} {numberFormat(total)}
                  </p>
                </div>
                {content}
                {path && path.includes('embed') && (
                  <Row>
                    <Column style={{ textAlign: 'center' }}>
                      <EmbedText>
                        Powered by &copy; {new Date().getFullYear()}{' '}
                        <a
                          href="https://mookh.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          MOOKH
                        </a>{' '}
                        Africa | Making Commerce Social.
                      </EmbedText>
                    </Column>
                  </Row>
                )}
              </Payment>
            </TabPanel>
            <TabPanel>
              <Description description={res.description} />
            </TabPanel>
          </Tabs>
        </TabsWrapper>
      </Tickets>
      {path && !path.includes('embed') && storeLoading ? (
        <Loader />
      ) : path && !path.includes('embed') && filteredStores.length ? (
        <MoreEvents>
          <Container>
            <MoreEventsDescription>
              More from{' '}
              <Link to={`/store/event/${res.storeSlug}`}>
                {' '}
                {res.store.name}
              </Link>
            </MoreEventsDescription>
            <Row style={{ marginTop: 28 }}>
              {filteredStores.slice(0, 4).map(event => {
                const {
                  id,
                  event_name,
                  store_name,
                  event_poster,
                  start_date,
                  end_date,
                  event_venue,
                  slug
                } = event;
                return (
                  <Column key={id}>
                    <EventsCard
                      title={event_name}
                      storeName={store_name}
                      imgSrc={event_poster}
                      startDate={start_date}
                      endDate={end_date}
                      location={event_venue}
                      to={`/event/${slug}`}
                    />
                  </Column>
                );
              })}
            </Row>
          </Container>
        </MoreEvents>
      ) : null}
    </Suspense>
  );
}

export default withRouter(MobilePage);
